import { makeAutoObservable } from 'mobx';
import { ChipId } from '@/types/ids';
import type {
  IChipEditorModel,
  IChipModel,
  ICircuitEditorModel,
} from '@/interfaces/models';
import { CircuitType } from '@/schemas/common';

export class ChipEditorModel implements IChipEditorModel {
  public chipModel: IChipModel;
  chipId: ChipId;
  private selectedEditingMode: CircuitType = CircuitType.ChipLogic;
  get editingMode(): CircuitType {
    if (this.chipModel.templateType)
      return this.chipModel.templateType === 'logic'
        ? CircuitType.ChipLogic
        : CircuitType.ChipStructure;
    return this.chipModel.kind === 'bundle-adapter'
      ? CircuitType.ChipStructure
      : this.selectedEditingMode;
  }
  set editingMode(mode: CircuitType) {
    this.selectedEditingMode =
      this.chipModel.kind === 'bundle-adapter' ? CircuitType.ChipStructure : mode;
  }
  settingOrigin: boolean = false;

  logicCircuitEditor: ICircuitEditorModel;
  structureCircuitEditor: ICircuitEditorModel;

  constructor({
    chipModel,
    logicCircuitEditor,
    structureCircuitEditor,
    editingMode = CircuitType.ChipLogic,
  }: {
    chipModel: IChipModel;
    logicCircuitEditor: ICircuitEditorModel;
    structureCircuitEditor: ICircuitEditorModel;
    editingMode?: CircuitType;
  }) {
    this.chipModel = chipModel;
    this.chipId = chipModel.id;
    this.logicCircuitEditor = logicCircuitEditor;
    this.structureCircuitEditor = structureCircuitEditor;
    this.editingMode =
      chipModel.kind === 'bundle-adapter' ? CircuitType.ChipStructure : editingMode;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get currentCircuitEditor() {
    if (this.chipModel.kind === 'bundle-adapter') return this.structureCircuitEditor;
    return {
      [CircuitType.ChipLogic]: this.logicCircuitEditor,
      [CircuitType.ChipStructure]: this.structureCircuitEditor,
    }[this.editingMode];
  }
}
